/**
 * Can this browser record a canvas frame by frame, and how?
 *
 * Deliberately dependency-free and separate from the recorder itself, so a
 * caller can ask the question without pulling in the answer: the video panel
 * asks eagerly, and `frameRecorder` reaches an encoder while `Lap3D/exportVideo`
 * reaches the HUD and through it ~800 kB of three.js.
 */

export const hasWebCodecs = () => typeof window !== 'undefined'
  && typeof window.VideoEncoder === 'function'
  && typeof window.VideoFrame === 'function';

/**
 * Does this engine implement on-demand canvas frames?
 *
 * `captureStream` being present is not the question — Firefox has it and returns
 * a perfectly good track whose `requestFrame` is undefined. Only probing a real
 * track answers it, so probe a 1×1 throwaway.
 */
export function hasRequestFrame() {
  if (typeof window === 'undefined'
    || typeof window.MediaRecorder !== 'function'
    || typeof HTMLCanvasElement.prototype.captureStream !== 'function') return false;
  try {
    const probe = document.createElement('canvas');
    probe.width = 1;
    probe.height = 1;
    probe.getContext('2d');
    const [track] = probe.captureStream(0).getVideoTracks();
    const ok = !!track && typeof track.requestFrame === 'function';
    track?.stop();
    return ok;
  } catch {
    return false;
  }
}

/** Is browser-side capture possible at all, by either route? */
export function canExportVideo() {
  return hasWebCodecs() || hasRequestFrame();
}
